import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'
export default {
  name: 'ajustesCargos',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],
      comercios_f: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }
    }
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: [],
    });
    $('.box').boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function () {
      return (
        "/reportes/ajustes/cargos?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/ajustes/cargos', this.f_c)
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              response.data.data[i][8] = this.num_to_many(response.data.data[i][8]);
              response.data.data[i][18] = this.num_to_many(response.data.data[i][18]);
              response.data.data[i][17] = this.num_to_many(response.data.data[i][17]);
              this.tbv.row.add(response.data.data[i]);
            }
          }
          this.tbv.draw();
          this.loading = false;
        }).catch(error => {
             this.loading = false;
        });
    },
  }
} 



// WEBPACK FOOTER //
// ./src/components/reportes/ajustesCargos/index.js